(function () {
  'use strict';

  var filters = {
    collection: '',
    issued: '',
    number: '',
    search: '',
    productQuery: ''
  };

  var activeCollections = [];
  var GLOBAL_PRODUCTS = [];

  function buildGlobalProductList() {
    var seen = {};
    document.querySelectorAll('#ak-cert-cards .ak-cert-card').forEach(function (card) {
      var titles = (card.dataset.productTitles || '').split('||');
      var skus   = (card.dataset.productSkus   || '').split('||');
      titles.forEach(function (title, i) {
        title = title.trim();
        var sku = (skus[i] || '').trim();
        if (!title) return;
        var key = title.toLowerCase() + '|' + sku.toLowerCase();
        if (!seen[key]) {
          seen[key] = true;
          GLOBAL_PRODUCTS.push({
            title:     title,
            sku:       sku,
            titleNorm: title.toLowerCase(),
            skuNorm:   sku.toLowerCase()
          });
        }
      });
    });
  }

  function getCards() {
    return document.querySelectorAll('#ak-cert-cards .ak-cert-card');
  }

  function norm(str) {
    return (str || '').toLowerCase().trim();
  }

  /* ── FIX: norm() every part individually after split ── */
  function anyCollectionMatches(cardCol) {
    if (activeCollections.length === 0) return true;
    var parts = cardCol.split(',').map(function(p){ return norm(p); });
    return activeCollections.some(function (ac) {
      return parts.indexOf(norm(ac)) !== -1;
    });
  }

  function applyFilters() {
    var cards = getCards();
    var visibleCount = 0;

    cards.forEach(function (card) {
      if (shouldShow(card)) {
        card.classList.remove('is-hidden');
        visibleCount++;
      } else {
        card.classList.add('is-hidden');
      }
    });

    var noResults = document.getElementById('ak-cert-no-results');
    if (noResults) {
      noResults.style.display = visibleCount === 0 ? 'block' : 'none';
    }

    updateActiveChips();
  }

  function shouldShow(el) {
    var col           = (el.dataset.collection    || '').trim();
    var issued        = norm(el.dataset.issued     || '');
    var number        = norm(el.dataset.number     || '');
    var title         = norm(el.dataset.title      || '');

    /* ── FIX: split by || and trim each part individually ── */
    var productTitlesRaw = (el.dataset.productTitles || '');
    var productSkusRaw   = (el.dataset.productSkus   || '');
    var productTitleParts = productTitlesRaw.split('||').map(function(p){ return p.trim().toLowerCase(); });
    var productSkuParts   = productSkusRaw.split('||').map(function(p){ return p.trim().toLowerCase(); });

    /* Multi-collection filter */
    if (!anyCollectionMatches(col)) return false;

    /* Dropdown: issued */
    if (filters.issued && issued !== norm(filters.issued)) return false;

    /* Dropdown: number */
    if (filters.number && number !== norm(filters.number)) return false;

    /* ── FIX: product filter checks each part individually ── */
    if (filters.productQuery) {
      var q = norm(filters.productQuery);
      var matchesProd = productTitleParts.some(function(t){ return t.indexOf(q) !== -1; })
                     || productSkuParts.some(function(s){   return s.indexOf(q) !== -1; });
      if (!matchesProd) return false;
    }

    /* Free-text search: title OR cert number OR any product title OR any product SKU */
    if (filters.search) {
      var sq = norm(filters.search);
      var matchesSearch = title.indexOf(sq) !== -1
                       || number.indexOf(sq) !== -1
                       || productTitleParts.some(function(t){ return t.indexOf(sq) !== -1; })
                       || productSkuParts.some(function(s){   return s.indexOf(sq) !== -1; });
      if (!matchesSearch) return false;
    }

    return true;
  }

  /* ── Active chips display ── */
  function updateActiveChips() {
    var wrap = document.getElementById('ak-cert-active-chips');

    if (!wrap) return;

    wrap.innerHTML = '';
    var hasChips = false;

    activeCollections.forEach(function (col) {
      hasChips = true;
      wrap.appendChild(makeChip(col, function () { removeCollection(col); }));
    });

    if (filters.issued) {
      hasChips = true;
      wrap.appendChild(makeChip('Issuer: ' + filters.issued, function () {
        filters.issued = '';
        var sel = document.getElementById('cert-filter-issued');
        if (sel) sel.value = '';
        applyFilters();
      }));
    }

    if (filters.number) {
      hasChips = true;
      wrap.appendChild(makeChip('No: ' + filters.number, function () {
        filters.number = '';
        var sel = document.getElementById('cert-filter-number');
        if (sel) sel.value = '';
        applyFilters();
      }));
    }

    if (filters.productQuery) {
      hasChips = true;
      wrap.appendChild(makeChip('Product: ' + filters.productQuery, function () {
        filters.productQuery = '';
        var inp = document.getElementById('ak-cert-search-input');
        if (inp) inp.value = '';
        applyFilters();
      }));
    }

    if (filters.search) {
      hasChips = true;
      wrap.appendChild(makeChip('Search: ' + filters.search, function () {
        filters.search = '';
        var input = document.getElementById('ak-cert-search-input');
        if (input) input.value = '';
        applyFilters();
      }));
    }

    wrap.style.display = hasChips ? 'flex' : 'none';
  }

  function makeChip(label, onRemove) {
    var chip = document.createElement('span');
    chip.className = 'ak-cert-active-chip';
    chip.textContent = label;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Remove filter: ' + label);
    btn.textContent = '×';
    btn.addEventListener('click', onRemove);
    chip.appendChild(btn);
    return chip;
  }

  /* ── Collection helpers ── */
  function addCollection(col) {
    if (activeCollections.indexOf(col) === -1) activeCollections.push(col);
  }

  function removeCollection(col) {
    activeCollections = activeCollections.filter(function (c) { return c !== col; });
    document.querySelectorAll('.ak-cert-pill[data-collection]').forEach(function (pill) {
      if (pill.dataset.collection === col) pill.classList.remove('is-active');
    });
    document.querySelectorAll('.ak-cert-std-check[data-collection]').forEach(function (chk) {
      if (chk.dataset.collection === col) chk.checked = false;
    });
    var sel = document.getElementById('cert-filter-collection');
    if (sel && sel.value === col) sel.value = '';
    applyFilters();
  }

  function setCollectionExclusive(col) {
    activeCollections = col ? [col] : [];
    document.querySelectorAll('.ak-cert-pill[data-collection]').forEach(function (pill) {
      pill.classList.toggle('is-active', pill.dataset.collection === col);
    });
    document.querySelectorAll('.ak-cert-std-check[data-collection]').forEach(function (chk) {
      chk.checked = chk.dataset.collection === col;
    });
    applyFilters();
  }

  /* ── Reset ── */
  function resetAll() {
    activeCollections    = [];
    filters.issued       = '';
    filters.number       = '';
    filters.search       = '';
    filters.productQuery = '';

    document.querySelectorAll('.ak-cert-select').forEach(function (s) { s.value = ''; });
    document.querySelectorAll('.ak-cert-pill').forEach(function (p) { p.classList.remove('is-active'); });
    document.querySelectorAll('.ak-cert-std-check').forEach(function (c) { c.checked = false; });

    var inp = document.getElementById('ak-cert-search-input');
    if (inp) inp.value = '';

    hideAutocomplete();
    applyFilters();
  }

  function scrollToGallery() {
    var gallery = document.getElementById('ak-cert-cards');
    if (gallery) gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ── Autocomplete ── */
  var autocompleteBox = null;
  var currentSuggestions = [];
  var selectedIndex = -1;
  var SKU_LABEL = (document.getElementById('ak-cert-search-input') || {}).dataset
    ? ((document.getElementById('ak-cert-search-input') || {}).dataset.skutext || 'SKU')
    : 'SKU';

  function createAutocompleteBox(inputEl) {
    autocompleteBox = document.createElement('ul');
    autocompleteBox.id = 'ak-cert-autocomplete';
    autocompleteBox.setAttribute('role', 'listbox');
    autocompleteBox.style.cssText = [
      'position:absolute',
      'z-index:9999',
      'overflow-y:auto',
      'min-width:100%',
      'width:100%'
    ].join(';');

    var wrap = inputEl.closest('.ak-cert-search-input-wrap') || inputEl.parentElement;
    wrap.style.position = 'relative';
    wrap.appendChild(autocompleteBox);
  }

  function showAutocomplete(inputEl, query) {
    if (!autocompleteBox) createAutocompleteBox(inputEl);

    var q = norm(query);
    if (!q || q.length < 1) { hideAutocomplete(); return; }

    currentSuggestions = GLOBAL_PRODUCTS.filter(function (p) {
      return p.titleNorm.indexOf(q) !== -1 || p.skuNorm.indexOf(q) !== -1;
    }).slice(0, 10);

    if (currentSuggestions.length === 0) { hideAutocomplete(); return; }

    selectedIndex = -1;
    autocompleteBox.innerHTML = '';

    currentSuggestions.forEach(function (prod, i) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.setAttribute('data-index', i);

      var titleSpan = document.createElement('span');
      titleSpan.textContent = prod.title;
      li.appendChild(titleSpan);

      if (prod.sku) {
        var skuSpan = document.createElement('span');
        skuSpan.textContent = SKU_LABEL + ': ' + prod.sku;
        skuSpan.style.cssText = 'opacity:0.98;';
        li.appendChild(skuSpan);
      }

      li.addEventListener('mouseenter', function () {
        clearHighlight();
        selectedIndex = i;
      });
      li.addEventListener('mouseleave', function () {
        li.style.background = '';
      });
      li.addEventListener('mousedown', function (e) {
        e.preventDefault();
        selectSuggestion(inputEl, prod);
      });

      autocompleteBox.appendChild(li);
    });

    autocompleteBox.style.display = 'block';
  }

  function hideAutocomplete() {
    if (autocompleteBox) autocompleteBox.style.display = 'none';
    selectedIndex = -1;
    currentSuggestions = [];
  }

  function clearHighlight() {
    if (!autocompleteBox) return;
    autocompleteBox.querySelectorAll('li').forEach(function (li) {
      li.style.background = '';
    });
  }

  function highlightItem(index) {
    clearHighlight();
    if (!autocompleteBox) return;
    var items = autocompleteBox.querySelectorAll('li');
    if (index >= 0 && index < items.length) {
      items[index].style.background = 'var(--color-background-2, #f5f5f5)';
      items[index].scrollIntoView({ block: 'nearest' });
    }
  }

  function selectSuggestion(inputEl, prod) {
    inputEl.value = prod.title;
    filters.productQuery = prod.title;
    filters.search       = '';
    hideAutocomplete();
    applyFilters();
    scrollToGallery();
  }

  /* ── Init ── */
  function init() {
    buildGlobalProductList();

    document.querySelectorAll('.ak-cert-select').forEach(function (select) {
      select.addEventListener('change', function () {
        var key = this.dataset.filter;
        var val = this.value.trim();
        if (key === 'collection') {
          setCollectionExclusive(val);
        } else {
          filters[key] = val;
          applyFilters();
        }
      });
    });

    var resetBtn = document.getElementById('cert-reset-filters');
    if (resetBtn) resetBtn.addEventListener('click', resetAll);

    document.querySelectorAll('.ak-cert-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var col = this.dataset.collection;
        if (this.classList.contains('is-active')) {
          removeCollection(col);
        } else {
          this.classList.add('is-active');
          addCollection(col);
          applyFilters();
        }
        var sel = document.getElementById('cert-filter-collection');
        if (sel) sel.value = activeCollections.length === 1 ? activeCollections[0] : '';
        scrollToGallery();
      });
    });

    document.querySelectorAll('.ak-cert-std-check').forEach(function (chk) {
      chk.addEventListener('change', function () {
        var col = this.dataset.collection;
        if (this.checked) {
          addCollection(col);
        } else {
          activeCollections = activeCollections.filter(function (c) { return c !== col; });
        }
        document.querySelectorAll('.ak-cert-pill[data-collection="' + col + '"]').forEach(function (p) {
          p.classList.toggle('is-active', chk.checked);
        });
        var sel = document.getElementById('cert-filter-collection');
        if (sel) sel.value = activeCollections.length === 1 ? activeCollections[0] : '';
        applyFilters();
      });
    });

    /* ── Search with autocomplete ── */
    var searchInput = document.getElementById('ak-cert-search-input');
    if (searchInput) {
      var searchTimer;

      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        var val = this.value;

        if (filters.productQuery && norm(val) !== norm(filters.productQuery)) {
          filters.productQuery = '';
        }

        showAutocomplete(searchInput, val);

        searchTimer = setTimeout(function () {
          if (!filters.productQuery) {
            filters.search = val.trim();
            applyFilters();
          }
        }, 220);
      });

      searchInput.addEventListener('keydown', function (e) {
        if (!autocompleteBox || autocompleteBox.style.display === 'none') return;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          selectedIndex = Math.min(selectedIndex + 1, currentSuggestions.length - 1);
          highlightItem(selectedIndex);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          selectedIndex = Math.max(selectedIndex - 1, 0);
          highlightItem(selectedIndex);
        } else if (e.key === 'Enter') {
          e.preventDefault();
          if (selectedIndex >= 0 && currentSuggestions[selectedIndex]) {
            selectSuggestion(searchInput, currentSuggestions[selectedIndex]);
          } else {
            filters.search       = searchInput.value.trim();
            filters.productQuery = '';
            hideAutocomplete();
            applyFilters();
            scrollToGallery();
          }
        } else if (e.key === 'Escape') {
          hideAutocomplete();
        }
      });

      searchInput.addEventListener('blur', function () {
        setTimeout(hideAutocomplete, 150);
      });

      searchInput.addEventListener('focus', function () {
        if (this.value) showAutocomplete(searchInput, this.value);
      });
    }

    var filterStdBtn = document.getElementById('ak-cert-filter-standard-btn');
    if (filterStdBtn) {
      filterStdBtn.addEventListener('click', function () {
        scrollToGallery();
      });
    }

    var dlBtn = document.getElementById('ak-cert-download-all-btn');
    if (dlBtn) {
      dlBtn.addEventListener('click', function () {
        var links = [];
        document.querySelectorAll('#ak-cert-cards .ak-cert-card:not(.is-hidden) .ak-cert-btn-download').forEach(function (a) {
          if (a.href) links.push(a.href);
        });
        if (links.length === 0) { scrollToGallery(); return; }
        links.slice(0, 5).forEach(function (href) {
          var a = document.createElement('a');
          a.href = href; a.download = ''; a.style.display = 'none';
          document.body.appendChild(a); a.click(); document.body.removeChild(a);
        });
      });
    }

    var seeAllBtn = document.getElementById('ak-cert-see-all');
    if (seeAllBtn) {
      seeAllBtn.addEventListener('click', function () {
        resetAll();
        scrollToGallery();
      });
    }

    var heroCta = document.getElementById('ak-cert-hero-cta');
    if (heroCta) heroCta.addEventListener('click', scrollToGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


/* ── Products collapsible ── */
